export function readUnpaidProductAccess(response: unknown): 0 | 1 | null {
  const candidates = [response, (response as { data?: unknown })?.data];
  for (const body of candidates) {
    if (body == null || typeof body !== 'object') {
      continue;
    }
    const raw = (body as Record<string, unknown>)['is_prism_access'];
    if (raw === 0 || raw === 1 || raw === '0' || raw === '1') {
      return Number(raw) as 0 | 1;
    }
  }
  return null;
}

/** Only explicit `access: 1` grants access. */
export function isUnpaidProductAuthorized(response: unknown): boolean {
  return readUnpaidProductAccess(response) === 1;
}

/** `access: 0` or missing (or any non-1 value) → unauthorized. */
export function isUnpaidProductUnauthorized(response: unknown): boolean {
  return !isUnpaidProductAuthorized(response);
}

/** Detect access denial on API success/error payloads (including axios-style errors). */
export function isUnpaidAccessDeniedSource(source: unknown): boolean {
  if (isUnpaidProductUnauthorized(source)) {
    return true;
  }

  const errorLike = source as {
    response?: { data?: unknown };
    error?: unknown;
  };

  return (
    isUnpaidProductUnauthorized(errorLike?.response?.data) ||
    isUnpaidProductUnauthorized(errorLike?.error)
  );
}
